import * as React from 'react';
import * as classnames from 'classnames/bind';
import bind from 'bind-decorator';
import {observer} from 'mobx-react';
import {action, observable} from 'mobx';
import {InputFieldProps} from '@mintdata-wsp/wsp/ui/components/forms/InputField';
import {Row} from '@mintdata-wsp/wsp/ui/components/forms/Row';
import {MDIcon} from '@mintdata-wsp/common/components/icon/MDIcon';
import {MDIcons} from '@mintdata-wsp/common/components/icon/MDIcons';

const styles = require('./Dropdown.less');
const cx = classnames.bind(styles);

export class DropdownItem
{
    constructor(public name:string,
                public value:string)
    {
    }
}

export interface DropdownProps extends InputFieldProps
{
    items:DropdownItem[];
    className?:string;
    selectClassName?:string;
    placeholder?:string;
}

@observer
export class Dropdown extends React.Component<DropdownProps, any>
{
    @observable
    private _selectedItem:DropdownItem = null;

    constructor(props:DropdownProps)
    {
        super(props);
        this._init(props);
    }

    componentWillReceiveProps(props:DropdownProps):void
    {
        this._init(props);
    }

    @action.bound
    private _init(props:DropdownProps)
    {
        const {initialValue} = props;
        this._selectedItem = initialValue? this._findItemForValue(initialValue) : null;
    }

    @bind
    private _onChange(e: React.FormEvent<HTMLSelectElement>)
    {
        const {onChange} = this.props;

        const value = e.currentTarget.value;
        const foundItem = this._findItemForValue(value);

        if( onChange && typeof onChange === 'function' )
            onChange(foundItem);
    }

    private _findItemForValue(value:string):DropdownItem|null
    {
        const {items} = this.props;
        const foundItem = items.find((item:DropdownItem)=>(item.value === value));

        return foundItem;
    }

    render()
    {
        let {items, className, placeholder, selectClassName} = this.props;
        const selectedValue = this._selectedItem?this._selectedItem.value:'';

        return  <Row className={cx('dropdownWrapper', className)}>
                    <select value={selectedValue} className={cx('dropdown', selectClassName)} onChange={this._onChange}>

                    {placeholder?<option selected={true} disabled value={'placeholder'}>{placeholder}</option>:null}

                    {
                        items.map((item)=>
                        {
                            // const isSelected = this._selectedItem && this._selectedItem.value === item.value;
                            return  <option key={item.name} value={item.name}>
                                            {item.value}
                                    </option>;
                        })
                    }
                    </select>
                    {/*<Row className={cx('dropdownDownArrow')}>*/}
                        <MDIcon className={cx({reverseIcon:false}, 'icon', 'dropdownDownArrow')} name={MDIcons.common.ArrowDropdown}/>
                    {/*</Row>*/}
                </Row>;
    }
}
